<!-- MODAL NEWS -->
<div *ngFor="let news of unreadNews">
    <div *ngIf="news.displayOptions?.includes('popup') || news.displayOptions?.includes('popupWithoutReadOption')">
        <div class="modal is-active">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">News</p>
                </header>
                <section class="modal-card-body">
                    <iw-shop-news-template [loadId]="news.id" [markNewsAsRead]="false"></iw-shop-news-template>
                </section>
                <footer class="modal-card-foot has-text-centered">
                    <button class="button is-success m-auto" (click)="setReadNews(news.id)">Gelesen</button>
                </footer>
            </div>
        </div>
    </div>
</div>
